import React from 'react';
import { DateTime } from 'luxon';

/**
 * Interface definition for DateTimeOutput component's props objects.
 */
export interface DateTimeOutputProps {
    isoValue: string,
    format?: string
}

/**
 * Standard output component for displaying the standard date time display.
 * @param props 
 * @returns 
 */
const DateTimeOutput: React.FunctionComponent<DateTimeOutputProps> = (props: DateTimeOutputProps) => {
    /**
     * Display the converted date time string based on the provided string format.
     * @returns 
     */
    const displayDate = (): string => {
        if (!props.format) {
            return 'No format was specified.';
        }

        const date = DateTime.fromISO(props.isoValue).toFormat(props.format);

        return date;
    }

    return (
        <span>
            {displayDate()}
        </span>
    )
}

/**
 * Set the default DateTimeOutput component props value, especially the format.
 */
DateTimeOutput.defaultProps = {
    format: 'dd - LL - y'
}

export default DateTimeOutput;